(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7951],{

/***/ 38708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ AddressInstructionsModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Image/index.tsx
var Image = __webpack_require__(56036);
// EXTERNAL MODULE: ./src/components/NoSSR/index.tsx
var NoSSR = __webpack_require__(4295);
// EXTERNAL MODULE: ./src/components/SafeSuspenseLoading/index.tsx
var SafeSuspenseLoading = __webpack_require__(11501);
// EXTERNAL MODULE: ./src/components/V3/Button/index.tsx
var Button = __webpack_require__(1555);
// EXTERNAL MODULE: ./src/components/V3/Modal/index.tsx + 1 modules
var Modal = __webpack_require__(12652);
// EXTERNAL MODULE: ./src/helpers/analytics/events/index.ts + 3 modules
var events = __webpack_require__(54646);
// EXTERNAL MODULE: ./src/helpers/analytics/sendEvents.ts
var sendEvents = __webpack_require__(76110);
// EXTERNAL MODULE: ./src/helpers/websites/doesCountryRequireCookies.ts
var doesCountryRequireCookies = __webpack_require__(2840);
// EXTERNAL MODULE: ./src/hooks/useLocalStorageState.ts
var useLocalStorageState = __webpack_require__(54501);
// EXTERNAL MODULE: ./src/page-components/Layout/useInitialData.ts
var useInitialData = __webpack_require__(62832);
;// CONCATENATED MODULE: ./src/hooks/useCookiesAnswered.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



function useCookiesAnswered() {
    var ref;
    var ref1 = _slicedToArray((0,useLocalStorageState/* default */.Z)("prompCookies", null), 1), prompCookies = ref1[0];
    var initialData = (0,useInitialData/* default */.Z)();
    if (!(0,doesCountryRequireCookies/* default */.Z)(initialData === null || initialData === void 0 ? void 0 : (ref = initialData.website) === null || ref === void 0 ? void 0 : ref.countryCode)) return true;
    if (prompCookies === null) return false;
    return true;
};

// EXTERNAL MODULE: ./src/hooks/useEventsBaseProperties.ts
var useEventsBaseProperties = __webpack_require__(87037);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/components/AddressInstructionsModal/useAddressModalPreferences.main.tsx
var useAddressModalPreferences_main = __webpack_require__(90479);
;// CONCATENATED MODULE: ./src/components/AddressInstructionsModal/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}















function AddressInstructionsModalInner(props) {
    var isOpen = props.isOpen, setOpen = props.setOpen, setOpenAddressModal = props.setOpenAddressModal;
    var website = (0,useInitialData/* default */.Z)().website;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "addressInstructions"
    }).t;
    var cookiesAnswered = useCookiesAnswered();
    var baseEventProperties = (0,useEventsBaseProperties/* default */.Z)();
    var ref = (0,useAddressModalPreferences_main/* default */.Z)(), showAddressModal = ref.showAddressModal, submitAddressPreference = ref.submitAddressPreference;
    (0,react.useEffect)(function() {
        if (isOpen && showAddressModal) {
            (0,sendEvents/* sendEvent */.q)(events/* EVENTS.browse.addressStartViewed */.F.browse.addressStartViewed, baseEventProperties);
        }
    }, [
        isOpen,
        showAddressModal
    ]);
    if (!isOpen || !showAddressModal) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        onClose: _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return setOpenAddressModal(false);
                    case 2:
                        _ctx.next = 4;
                        return setOpen(false);
                    case 4:
                        submitAddressPreference(false);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        isOpen: isOpen,
        compact: true,
        showClose: false,
        className: "dark:bg-zinc-800 font-sans",
        canClickOutside: cookiesAnswered,
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeSuspenseLoading/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pb-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            priority: true,
                            src: website.logo.url,
                            alt: website.name || "Logo",
                            title: website.name || "logo",
                            objectFit: "contain",
                            height: 75,
                            width: 75
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "font-normal",
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-bold text-3xl",
                        children: website.name
                    })
                ]
            })
        }),
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "pt-4 pb-8 flex justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "underline cursor-pointer",
                onClick: _asyncToGenerator(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return setOpenAddressModal(false);
                            case 2:
                                _ctx.next = 4;
                                return setOpen(false);
                            case 4:
                                submitAddressPreference(false);
                            case 5:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                })),
                children: t("cancel")
            })
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SafeSuspenseLoading/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-8 pb-4",
                    children: [
                        t("body"),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-bold",
                            children: t("bodyBold")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "px-8 pb-4",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        primary: true,
                        full: true,
                        big: true,
                        className: "rounded-lg",
                        onClick: _asyncToGenerator(runtime_default().mark(function _callee() {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.next = 2;
                                        return setOpen(false);
                                    case 2:
                                        setOpenAddressModal(true);
                                        submitAddressPreference(false);
                                    case 4:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        })),
                        children: t("continueToDirections")
                    })
                })
            ]
        })
    });
}
function AddressInstructionsModal(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInstructionsModalInner, _objectSpread({}, props))
    });
};


/***/ }),

/***/ 98816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ClickOutsideCustom; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_click_outside__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48683);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



function ClickOutsideCustom(props) {
    var avoidElementName = props.avoidElementName, avoidElementsClass = props.avoidElementsClass, children = props.children, onClickOutsideProps = props.onClickOutside, otherProps = _objectWithoutProperties(props, [
        "avoidElementName",
        "avoidElementsClass",
        "children",
        "onClickOutside"
    ]);
    var onClickOutside = function(e) {
        if (avoidElementName) {
            var element = document.getElementById(avoidElementName);
            if (element && element.contains(e.target)) {
                return;
            }
        }
        if (avoidElementsClass) {
            var elements = document.getElementsByClassName(avoidElementsClass);
            if ((elements === null || elements === void 0 ? void 0 : elements.length) && _toConsumableArray(elements).some(function(element) {
                return element.contains(e.target);
            })) {
                return;
            }
        }
        return onClickOutsideProps === null || onClickOutsideProps === void 0 ? void 0 : onClickOutsideProps(e);
    };
    return(// react-click-outside passes the other props to the div containing the children
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_click_outside__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, otherProps, {
        onClickOutside: onClickOutside,
        children: children
    })));
};


/***/ }),

/***/ 66508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCartPreferences; }
/* harmony export */ });
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getCartPreferences($websiteId: ID!) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          menuId\n          tableName\n          deliveryType\n          storeId\n          cart {\n            itemsPrice\n            totalPrice\n            items {\n              _id\n            }\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useCartPreferences() {
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var preferences = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_1__/* .useApolloQuery */ .Zu)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_2__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first"
    }).preferences;
    return preferences;
};


/***/ }),

/***/ 98581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CartMenuV2; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/index.js
var lib = __webpack_require__(5275);
// EXTERNAL MODULE: ./src/components/AddressInstructionsModal/index.tsx + 1 modules
var AddressInstructionsModal = __webpack_require__(38708);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/index.tsx + 1 modules
var DeliveryWizard = __webpack_require__(16312);
// EXTERNAL MODULE: ./src/components/SafeSuspense/index.tsx
var SafeSuspense = __webpack_require__(5822);
// EXTERNAL MODULE: ./src/hooks/useEffect.ts
var useEffect = __webpack_require__(10338);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./src/hooks/useWebsiteAddressInstructionModal.main.tsx
var useWebsiteAddressInstructionModal_main = __webpack_require__(40073);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/Content/index.tsx + 6 modules
var Content = __webpack_require__(11900);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 50 modules
var esm = __webpack_require__(32533);
// EXTERNAL MODULE: ./src/page-components/Order/Cart/hooks/useCart.main.tsx
var useCart_main = __webpack_require__(66508);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/components/ClickOutside/index.tsx
var ClickOutside = __webpack_require__(98816);
// EXTERNAL MODULE: ./src/helpers/misc/sleep.ts
var sleep = __webpack_require__(77712);
// EXTERNAL MODULE: ./src/i18n/formatNumber/Component.tsx
var Component = __webpack_require__(18085);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./src/page-components/Order/CartMenuV2/CartMenu/styles.module.css
var styles_module = __webpack_require__(7529);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/CartMenuV2/CartMenu/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}










var CartMenu = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(CartMenu, _Component);
    var _super = _createSuper(CartMenu);
    function CartMenu() {
        _classCallCheck(this, CartMenu);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            className: "",
            showMessage: "close"
        };
        return _this;
    }
    var _proto = CartMenu.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var cart = this.props.cart;
        var total = cart && cart.totalPrice || 0;
        if (total) {
            this.showMessage();
        }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var cart = this.props.cart;
        var prevCart = prevProps.cart;
        if (!prevCart) return; // First load, skip animation
        var total = cart && cart.totalPrice || 0;
        var prevTotal = prevCart && prevCart.totalPrice || 0;
        if (total > prevTotal) {
            this.attention();
        }
        if (!prevTotal && total) {
            this.showMessage();
        }
    };
    _proto.attention = function attention() {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this.setState({
                            className: "animated shake"
                        });
                        _ctx.next = 3;
                        return (0,sleep/* default */.Z)(1000);
                    case 3:
                        _this.setState({
                            className: "animated"
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.showMessage = function showMessage() {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this.setState({
                            showMessage: "show"
                        });
                        _ctx.next = 3;
                        return (0,sleep/* default */.Z)(3000);
                    case 3:
                        _this.setState({
                            showMessage: "hide"
                        });
                        _ctx.next = 6;
                        return (0,sleep/* default */.Z)(1000);
                    case 6:
                        _this.setState({
                            showMessage: "close"
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.render = function render() {
        var _props = this.props, open = _props.open, onClick = _props.onClick, cart = _props.cart, setOpenOptions = _props.setOpenOptions, openOptions = _props.openOptions, optionsLabel = _props.optionsLabel;
        var total = cart && cart.itemsPrice || 0;
        var openClassName = total > 0 ? (styles_module_default()).cartHightlightMobile : "";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: openClassName + " " + (styles_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).inner,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: cart ? (styles_module_default()).addressCallToAction : (styles_module_default()).addressCallToActionLoading,
                                onClick: openOptions ? null : setOpenOptions,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).title,
                                        children: optionsLabel
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).icon,
                                        children: openOptions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdKeyboardArrowUp */.rWj, {
                                            size: 22
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdKeyboardArrowDown */.Ix0, {
                                            size: 22
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).divider,
                                onClick: open ? null : onClick
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (styles_module_default()).button,
                                onClick: open ? null : onClick,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).total + " " + this.state.className,
                                        children: cart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                                            value: total
                                        }) : ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdShoppingBasket */.Kvb, {
                                            size: 22,
                                            style: {
                                                marginRight: 5
                                            },
                                            "aria-label": "cart"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                this.state.showMessage !== "close" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).childrenContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: this.state.showMessage === "show" ? (styles_module_default()).message : (styles_module_default()).messageHide,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).arrowWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).arrowUp
                                    })
                                }),
                                this.props.t("order.titleOrderContinue")
                            ]
                        })
                    })
                }) : null,
                openOptions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: this.props.options
                }) : null,
                open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickOutside/* default */.Z, {
                        onClickOutside: onClick,
                        avoidElementName: "modal-root",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).childrenContainer,
                            children: this.props.children
                        })
                    })
                }) : null
            ]
        });
    };
    return CartMenu;
}(react.Component);
/* harmony default export */ var CartMenuV2_CartMenu = ((0,esm/* withTranslation */.Zh)()(CartMenu));

// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/useIsOutOfBounds.ts
var useIsOutOfBounds = __webpack_require__(58513);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/usePreferencesForAddressContext.main.ts
var usePreferencesForAddressContext_main = __webpack_require__(38417);
// EXTERNAL MODULE: ./src/helpers/misc/classnames.ts
var classnames = __webpack_require__(89894);
// EXTERNAL MODULE: ./src/page-components/Order/CartMenuV2/OptionsLabel/styles.module.css
var OptionsLabel_styles_module = __webpack_require__(64321);
var OptionsLabel_styles_module_default = /*#__PURE__*/__webpack_require__.n(OptionsLabel_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/CartMenuV2/OptionsLabel/index.tsx








function OptionsLabel() {
    var ref = (0,usePreferencesForAddressContext_main/* default */.Z)(), preferences = ref.preferences, loading = ref.loading;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.cartMenuV2.optionsLabel"
    }).t;
    var outOfBounds = (0,useIsOutOfBounds/* default */.Z)();
    if (!preferences || loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (OptionsLabel_styles_module_default()).loading
    });
    if (outOfBounds) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classnames/* default */.Z)((OptionsLabel_styles_module_default()).container, "flex items-center"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineWarning */.hid, {
                className: "w-5 h-5 mr-2 text-orange-200"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("outOfBounds")
            })
        ]
    });
    if (preferences.deliveryType === "delivery") {
        if (preferences.address) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (OptionsLabel_styles_module_default()).container,
                children: preferences.address.address
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (OptionsLabel_styles_module_default()).container,
                children: t("address")
            });
        }
    }
    if (!preferences.store) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (OptionsLabel_styles_module_default()).container,
            children: t("store")
        });
    }
    if (preferences.deliveryType === "go") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (OptionsLabel_styles_module_default()).container,
            children: t("storeGo", {
                store: preferences.store.name
            })
        });
    }
    var label = preferences.tableName ? t("labelTable", {
        table: preferences.tableName
    }) : t("labelServe");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (OptionsLabel_styles_module_default()).container,
        children: [
            preferences.store.name,
            ", ",
            label
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/CartMenuV2/Skeleton.tsx
var Skeleton = __webpack_require__(27457);
// EXTERNAL MODULE: ./src/page-components/Order/CartMenuV2/styles.module.css
var CartMenuV2_styles_module = __webpack_require__(66951);
var CartMenuV2_styles_module_default = /*#__PURE__*/__webpack_require__.n(CartMenuV2_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/CartMenuV2/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function CartMenuV2_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function CartMenuV2_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                CartMenuV2_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                CartMenuV2_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

















function CartMenuV2(props) {
    var loading = props.loading;
    var preferences = (0,useCart_main/* default */.Z)();
    var useAddressModal = (0,useWebsiteAddressInstructionModal_main/* default */.Z)();
    var ref = _slicedToArray((0,useState/* useState */.e)(false), 2), openAddressInstructionsModal = ref[0], setOpenAddressInstructionsModal = ref[1];
    var ref1 = _slicedToArray((0,useState/* useState */.e)(false), 2), open = ref1[0], setOpen = ref1[1];
    var ref2 = _slicedToArray((0,useState/* useState */.e)(false), 2), openOptions = ref2[0], setOpenOptions = ref2[1];
    var ref3 = _slicedToArray((0,useState/* useState */.e)(false), 2), hiddenPrice = ref3[0], setHiddenPrice = ref3[1];
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order"
    }).t;
    (0,useEffect/* useEffect */.d)(function() {
        if (!loading && !preferences.storeId && !useAddressModal) {
            setOpenOptions(true);
        }
    }, [
        loading,
        useAddressModal
    ]);
    (0,useEffect/* useEffect */.d)(function() {
        if (useAddressModal && !preferences.storeId) {
            setOpenOptions(false);
            setOpenAddressInstructionsModal(true);
        }
    }, [
        useAddressModal
    ]);
    (0,useEffect/* useEffect */.d)(function() {
        setHiddenPrice(false);
    }, [
        preferences
    ]);
    (0,lib/* useOnEvent */.dh)("hiddenPriceProductOpened", CartMenuV2_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setOpenOptions(true);
                    setHiddenPrice(true);
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })));
    var shouldShowOptions = !preferences.storeId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartMenuV2_CartMenu, {
                open: open,
                openOptions: openOptions,
                onClick: function() {
                    if (shouldShowOptions) setTimeout(function() {
                        return setOpenOptions(!openOptions);
                    });
                    else setTimeout(function() {
                        return setOpen(!open);
                    });
                },
                setOpenOptions: function() {
                    setTimeout(function() {
                        return setOpenOptions(!openOptions);
                    });
                },
                cart: preferences.cart,
                optionsLabel: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsLabel, {}),
                options: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryWizard/* default.AsModal */.Z.AsModal, {
                    isOpen: openOptions,
                    onClose: function() {
                        return setOpenOptions(false);
                    },
                    actionLocation: "cart"
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CartMenuV2_styles_module_default()).container,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SafeSuspense/* default */.Z, {
                        fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CartMenuV2_styles_module_default()).title,
                                children: t("titleMyOrder")
                            }),
                            preferences.cart ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Content/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
                        ]
                    })
                })
            }),
            useAddressModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInstructionsModal["default"], {
                isOpen: openAddressInstructionsModal,
                setOpen: setOpenAddressInstructionsModal,
                setOpenAddressModal: setOpenOptions
            }) : null
        ]
    });
};


/***/ }),

/***/ 7529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1bQ5DFEYpfetSmZY06QX7W backgroundBorderColor backgroundColor","button":"_1YZIoj0th_6B7NOJHPgL0_","addressCallToAction":"_2-HEcOI_-KKoBR6_kWIHwU _1YZIoj0th_6B7NOJHPgL0_ content primaryColor","addressCallToActionLoading":"F1j_VtgM8l06nrjKMhtbl _2-HEcOI_-KKoBR6_kWIHwU _1YZIoj0th_6B7NOJHPgL0_ content primaryColor","cartHightlightMobile":"_3OKG7QGPuwrnP8HcRDEN6l primaryBackgroundColor","flexItem":"_2C5OcTKuKGzLDF0SY2idub","inner":"Arpt_A3C3Jqu4n8qKcRTU _2C5OcTKuKGzLDF0SY2idub","title":"NkpkcUlswOOQ1gcvIyXPS _2C5OcTKuKGzLDF0SY2idub","total":"_1pgIPVynlf65eNmAgXJdK3 _2C5OcTKuKGzLDF0SY2idub","icon":"_2aeynOSTINZBPvOudeAcwh _2C5OcTKuKGzLDF0SY2idub","divider":"_3bPyKNZRxckttv9Lf_Tezl","message":"_3BxWMCaudCrhqO5zJAJhBR animated fadeIn","messageHide":"_2hhkOOXln9z6sSMDMrqWFh _3BxWMCaudCrhqO5zJAJhBR animated fadeIn fadeOut","arrowWrapper":"yh_CiHZ4JDSs1_z97wUH8","arrowUp":"_3-vwCg87NFXhvMKLx4Wr6O","childrenContainer":"Y5USBMwC-qBEXwm6ZWyby"};

/***/ }),

/***/ 64321:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_25TFeypo-VC6x_SRlhBUCq","loading":"_3oTnjcuokOSL6m44hTNfcL loadingGlow"};

/***/ })

}]);